import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Loader2, ChevronRight } from 'lucide-react';
export const ContextMenuItem = ({ item, onItemClick, onClose, hasSubmenu }) => {
    const handleClick = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (item.disabled || item.loading) {
            return;
        }
        // Submenu triggers don't have a primary action — clicking the row is a
        // no-op; the actual choice happens by hovering and clicking a submenu
        // item. Don't run item.action and don't close the menu.
        if (hasSubmenu) {
            return;
        }
        try {
            await item.action();
            onClose();
        }
        catch (error) {
            console.error('Context menu action error:', error);
        }
    };
    const IconComponent = item.icon;
    return (_jsxs("button", { onClick: handleClick, disabled: item.disabled || item.loading, className: `
        w-full px-3 py-2 text-xs text-left flex items-center gap-2
        transition-colors rounded-sm
        ${item.disabled || item.loading
            ? 'opacity-50 cursor-not-allowed'
            : 'cursor-pointer hover:bg-opacity-80'}
      `, style: {
            backgroundColor: item.disabled || item.loading ? 'var(--charcoal)' : 'var(--charcoal)',
            color: 'var(--dew)'
        }, onMouseEnter: (e) => {
            if (!item.disabled && !item.loading) {
                e.currentTarget.style.backgroundColor = 'var(--pewter)';
                e.currentTarget.style.color = 'var(--sand)';
            }
        }, onMouseLeave: (e) => {
            e.currentTarget.style.backgroundColor = 'var(--charcoal)';
            e.currentTarget.style.color = 'var(--dew)';
        }, children: [item.loading ? (_jsx(Loader2, { size: 14, className: "animate-spin" })) : (_jsx(IconComponent, { size: 14 })), _jsx("span", { className: "flex-1 truncate", children: item.label }), hasSubmenu && _jsx(ChevronRight, { size: 12, style: { opacity: 0.7 } })] }));
};
